import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import DatePicker from "react-datepicker";
import { format, parse, getYear  } from "date-fns";
import "./LeaveApply.css";
import { useDispatch, useSelector } from "react-redux";
import {
  cancelLeave,
  createLeave,
  getLeaveBalanceList,
  getLeaveList,
  getLeaveTypeList,
  getLeaveDetails,
} from "../../Redux/Leave/Action";
import Swal from "sweetalert2";
import { FaInfoCircle } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { FiCheckCircle } from "react-icons/fi";
import { FaEdit } from "react-icons/fa";
import { getBidList } from "../../Redux/Gem/Action";
import Select from "react-select";

const LeaveApply = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const loginId = localStorage.getItem("loginId");
  const [show, setShow] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [infoLeaveData, setInfoLeaveData] = useState(null);
  const [clList, setClList] = useState("");
  const { leavetypelist, leavebalancelist, leavelist, leavedetails } = useSelector(
    (store) => store.leave
  );
  const currentYear = new Date().getFullYear();

  const [selectedYear, setSelectedYear] = useState({
    value: currentYear,
    label: currentYear.toString(),
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    dispatch(getLeaveTypeList(token));
    dispatch(getLeaveBalanceList(token, loginId, 'Apply'));
    dispatch(getLeaveList(token, loginId, selectedYear?.value));
  }, [dispatch, token, loginId, selectedYear]);

  useEffect(() => {
    if (leavebalancelist) {
      const list = leavebalancelist.filter((leave) => leave.leaveCode === "CL")
      setClList(list?.[0]);
    }

  }, [leavebalancelist])

  const formatDate = (date) => {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const parseDate = (dateStr) => {
    if (!dateStr) return "";
    const parsed = parse(dateStr, "dd-MM-yyyy", new Date());
    return format(parsed, "yyyy-MM-dd"); // or whichever output format you need
  };

  const [leaveData, setLeaveData] = useState({
    leaveId: "",
    userId: loginId,
    leaveCode: "",
    dayType: "F",
    startDate: formatDate(new Date()),
    endDate: formatDate(new Date()),
    remark: "",
    actionType: "INSERT",
  });

  const statusMap = {
    S: "Success",
    A: "Applied",
    R: "Reverted",
  };
  const statusColorMap = {
    S: "text-success",
    A: "text-primary",
    R: "text-danger",
  };

  const handleChange = (e) => {
    const { id, value } = e.target;

    setLeaveData((prevData) => {
      let updatedData = {
        ...prevData,
        [id]: value,
      };

      if (updatedData.dayType === "H") {
        updatedData.endDate = updatedData.startDate;
      }

      return updatedData;
    });
  };

  const handleDateChange = (date, name) => {
    setLeaveData((prevData) => {
      let updatedData = {
        ...prevData,
        [name]: date ? format(date, "yyyy-MM-dd") : "",
      };

      //  For Half CL, endDate = startDate
      if (updatedData.dayType === "H" && name === "startDate") {
        updatedData.endDate = updatedData.startDate;
      }

      //  If startDate changes and is after endDate, auto-adjust endDate
      if (name === "startDate") {
        const start = new Date(date);
        const end = new Date(prevData.endDate);

        if (!prevData.endDate || start > end) {
          updatedData.endDate = format(start, "yyyy-MM-dd");
        }
      }

      return updatedData;
    });
  };

  const handleClose = () => {
    clearLeaveInputFields();
    setShow(false);
  };

  const handleInfoClose = () => {
    setShowInfo(false);
    setInfoLeaveData(null);
  };

  const clearLeaveInputFields = () => {
    setLeaveData({
      leaveId: "",
      userId: loginId,
      leaveCode: "",
      dayType: "F",
      startDate: formatDate(new Date()),
      endDate: formatDate(new Date()),
      remark: "",
      actionType: "INSERT",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!leaveData.startDate || !leaveData.endDate) {
      alert("Both Start And End Date Is Required");
      return;
    }
    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    });
    if (result.isConfirmed) {
      setIsSubmitting(true);
      dispatch(createLeave(token, leaveData))
        .then((response) => {
          if (response.statusMessage === "SUCCESS") {
            dispatch(getLeaveBalanceList(token, loginId, 'Apply'));
            dispatch(getLeaveList(token, loginId, selectedYear?.value));
            setShow(false);
            clearLeaveInputFields();
            Swal.fire({
              title: "Success!",
              text: response.statusDesc,
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: response.statusDesc,
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch(() => {
          Swal.fire({
            title: "Error!",
            text: "There was an error initiating the leave details.",
            icon: "error",
            confirmButtonText: "OK",
          });
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
  };

  const handleCancelLeave = async (leaveId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, cancel",
    });
    if (result.isConfirmed) {
      dispatch(cancelLeave(leaveId, token))
        .then((response) => {
          if (response.statusMessage === "SUCCESS") {
            dispatch(getLeaveBalanceList(token, loginId, 'Apply'));
            dispatch(getLeaveList(token, loginId, selectedYear?.value));
            Swal.fire({
              title: "Success!",
              text: response.statusDesc,
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: response.statusDesc,
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch(() => {
          Swal.fire({
            title: "Error!",
            text: "There was an error initiating the leave details.",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }
  };


  const handleInfoClick = (leave) => {
    setInfoLeaveData(leave);
    setShowInfo(true);
  }

  const handleLeaveEdit = (leaveId) => {
    dispatch(getLeaveDetails(token, leaveId));
    dispatch(getBidList(token));
  }

  useEffect(() => {
    if (leavedetails?.[0]) {
      const leave = leavedetails?.[0];
      setLeaveData({
        leaveId: leave.leaveId,
        userId: leave.loginId,
        leaveCode: leave.leaveCode,
        dayType: leave.dayType,
        startDate: parseDate(leave.startDate),
        endDate: parseDate(leave.endDate),
        remark: leave.remark,
        actionType: "UPDATE",
      });
      setShow(true);
    }

  }, [leavedetails])

  const Tooltip = ({ text, children }) => {
    return (
      <div className="tooltip-container">
        {children}
        <div className="tooltip">{text}</div>
      </div>
    );
  };

  // Generate last 10 years
  const yearOptions = Array.from({ length: 10 }, (_, i) => {
    const year = currentYear - i;
    return { value: year, label: year.toString() };
  });

  const handleYearChange = (option) => {
    setSelectedYear(option);
  };


  return (
    <div>
      <Navbar></Navbar>
      <div className="main-content">
        <div className="container-fluid mt-4">

          <div className="card p-4">
            <div
              className="card-header text-white"
              style={{
                background: "linear-gradient(90deg, #1e3c72 0%, #2a5298 100%)",
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
              }}
            >
              <div
                className="
      d-flex
      flex-column
      flex-md-row
      justify-content-center
      justify-content-md-between
      align-items-center
      gap-2
    "
              >
                {/* TITLE */}
                <h4 className="mb-0 fw-semibold text-center text-md-start">
                  Leave Details
                </h4>

                {/* RIGHT / CENTER CONTENT */}
                <div
                  className="
        d-flex
        flex-column
        flex-sm-row
        justify-content-center
        align-items-center
        gap-2
      "
                >
                  <button
                    type="button"
                    className="btn btn-light btn-sm fw-semibold apply-leave"
                    onClick={() => setShow(true)}
                  >
                    APPLY LEAVE
                  </button>

                  <div className="d-flex align-items-center">
                    {/* <b>
                      <label className="me-2 mb-0 custom-label text-white">
                        Year:
                      </label>
                    </b> */}

                    <div
                      className="filter-select text-dark"
                      style={{ minWidth: "100px" }}
                    >
                      <Select
                        options={yearOptions}
                        value={selectedYear}
                        onChange={handleYearChange}
                        placeholder="Select Year"
                        classNamePrefix="react-select"
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            borderRadius: "20px",
                            minHeight: "32px",
                            boxShadow: state.isFocused
                              ? "0 0 0 0.2rem rgba(13,110,253,.25)"
                              : "none",
                          }),
                          menu: base => ({
                            ...base,
                            borderRadius: "12px",
                          }),
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>



            {selectedYear?.value === getYear(new Date()) &&
              <div className="container my-3">
                <div className="row text-center g-3 leave-summary-row">

                  <div className="col-12 col-md">
                    <h6 className="mb-1">
                      Total Leave Entitlement (CL): {clList?.leaveDays + clList?.appliedDays || 0}
                    </h6>
                  </div>

                  <div className="col-12 col-md">
                    <h6 className="mb-1">
                      Leave Utilized: {clList?.appliedDays || 0}
                    </h6>
                  </div>

                  <div className="col-12 col-md">
                    <h6 className="mb-1">
                      Leave Balance Remaining: {clList?.leaveDays || 0}
                    </h6>
                  </div>

                </div>
              </div>
            }




            <div className="row mt-1">

              {/* ====== APPLIED CL ====== */}
              <div className="col-12 col-md-6 mb-3">
                <div className="card leave-wrapper-card shadow-sm rounded-4">
                  <div className="card-body text-center">

                    <h5 className="leave-title">Applied CL</h5>

                    {/* Desktop Table View */}
                    <div className="d-none d-md-block" style={{ maxHeight: "225px", overflowY: 'auto' }}>
                      <table className="table table-bordered table-striped table-hover modern-table">
                        <thead>
                          <tr>
                            <th>SN</th>
                            <th>Start</th>
                            <th>End</th>
                            <th>Days</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {leavelist && leavelist.filter(l => l.leaveCode === "CL").length > 0 ? (
                            leavelist
                              .filter(l => l.leaveCode === "CL")
                              .map((leave, index) => {
                                const [day, month, year] = leave.startDate.split("-");
                                const parsedStartDate = new Date(`${year}-${month}-${day}`);
                                const isFutureDate = parsedStartDate > new Date();

                                return (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{leave.startDate}</td>
                                    <td>{leave.endDate}</td>
                                    <td>{leave.noOfDays}</td>
                                    <td className={`${statusColorMap[leave.status]} fw-bold`}>
                                      {statusMap[leave.status]}
                                    </td>

                                    <td>
                                      <FaInfoCircle
                                        className="text-primary cursor-pointer me-2"
                                        onClick={() => handleInfoClick(leave)}
                                      />

                                      {isFutureDate && (
                                        <MdDeleteForever
                                          className="text-danger cursor-pointer me-2"
                                          size={20}
                                          onClick={() => handleCancelLeave(leave.leaveId)}
                                        />
                                      )}

                                      {leave.status !== "S" && (
                                        <FaEdit
                                          className="text-warning cursor-pointer"
                                          onClick={() => handleLeaveEdit(leave.leaveId)}
                                        />
                                      )}
                                    </td>
                                  </tr>
                                );
                              })
                          ) : (
                            <tr>
                              <td colSpan="6">No leave data available</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    {/* Mobile Card View */}
                    <div className="d-md-none">
                      {leavelist && leavelist.filter(l => l.leaveCode === "CL").length > 0 ? (
                        leavelist
                          .filter(l => l.leaveCode === "CL")
                          .map((leave, index) => {
                            const [day, month, year] = leave.startDate.split("-");
                            const parsedStartDate = new Date(`${year}-${month}-${day}`);
                            const isFutureDate = parsedStartDate > new Date();

                            return (
                              <div className="leave-mobile-card shadow-sm" key={index}>
                                <div><strong className="me-2 text-primary">Start:</strong> {leave.startDate}</div>
                                <div><strong className="me-2 text-primary">End:</strong> {leave.endDate}</div>
                                <div><strong className="me-2 text-primary">Days:</strong> {leave.noOfDays}</div>

                                <div>
                                  <strong className="me-2 text-primary">Status: </strong>
                                  <span className={`status-badge ${statusColorMap[leave.status]}`}>
                                    {statusMap[leave.status]}
                                  </span>
                                </div>

                                <div className="mobile-actions">
                                  <FaInfoCircle
                                    className="text-primary me-3"
                                    onClick={() => handleInfoClick(leave)}
                                  />

                                  {isFutureDate && (
                                    <MdDeleteForever
                                      className="text-danger me-3"
                                      size={20}
                                      onClick={() => handleCancelLeave(leave.leaveId)}
                                    />
                                  )}

                                  {leave.status !== "S" && (
                                    <FaEdit
                                      className="text-warning"
                                      onClick={() => handleLeaveEdit(leave.leaveId)}
                                    />
                                  )}
                                </div>
                              </div>
                            );
                          })
                      ) : (
                        <p>No leave data available</p>
                      )}
                    </div>

                  </div>
                </div>
              </div>

              {/* ====== APPLIED LOP ====== */}
              <div className="col-12 col-md-6 mb-3">
                <div className="card leave-wrapper-card shadow-sm rounded-4">
                  <div className="card-body text-center">

                    <h5 className="leave-title">Applied LOP</h5>

                    {/* Desktop Table */}
                    <div className="d-none d-md-block" style={{ maxHeight: "225px", overflowY: 'auto' }}>
                      <table className="table table-bordered table-striped table-hover modern-table">
                        <thead>
                          <tr>
                            <th>SN</th>
                            <th>Start</th>
                            <th>End</th>
                            <th>Days</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {leavelist && leavelist.filter(l => l.leaveCode === "LOP").length > 0 ? (
                            leavelist
                              .filter(l => l.leaveCode === "LOP")
                              .map((leave, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{leave.startDate}</td>
                                  <td>{leave.endDate}</td>
                                  <td>{leave.noOfDays}</td>
                                  <td className={`${statusColorMap[leave.status]} fw-bold`}>
                                    {statusMap[leave.status]}
                                  </td>

                                  <td>
                                    <FaInfoCircle
                                      className="text-primary cursor-pointer me-3"
                                      onClick={() => handleInfoClick(leave)}
                                    />

                                    {leave.status !== "S" && (
                                      <FaEdit
                                        className="text-warning cursor-pointer"
                                        onClick={() => handleLeaveEdit(leave.leaveId)}
                                      />
                                    )}
                                  </td>
                                </tr>
                              ))
                          ) : (
                            <tr>
                              <td colSpan="6">No leave data available</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    {/* Mobile – Card Layout */}
                    <div className="d-md-none">
                      {leavelist && leavelist.filter(l => l.leaveCode === "LOP").length > 0 ? (
                        leavelist
                          .filter(l => l.leaveCode === "LOP")
                          .map((leave, index) => (
                            <div className="leave-mobile-card" key={index}>
                              <div><strong className="me-2 text-primary">Start:</strong> {leave.startDate}</div>
                              <div><strong className="me-2 text-primary">End:</strong> {leave.endDate}</div>
                              <div><strong className="me-2 text-primary">Days:</strong> {leave.noOfDays}</div>

                              <div>
                                <strong className="me-2 text-primary">Status:</strong>
                                <span className={`status-badge ${statusColorMap[leave.status]}`}>
                                  {statusMap[leave.status]}
                                </span>
                              </div>

                              <div className="mobile-actions">
                                <FaInfoCircle
                                  className="text-primary me-3"
                                  onClick={() => handleInfoClick(leave)}
                                />

                                {leave.status !== "S" && (
                                  <FaEdit
                                    className="text-warning"
                                    onClick={() => handleLeaveEdit(leave.leaveId)}
                                  />
                                )}
                              </div>
                            </div>
                          ))
                      ) : (
                        <p>No leave data available</p>
                      )}
                    </div>

                  </div>
                </div>
              </div>

            </div>


            <hr />
            <div className="leave-notes-container">
              <em className="text-danger fw-bold">Leave Policy Notes :-</em>
              <div className="leave-note-item">
                <FiCheckCircle size={18} className="leave-note-icon text-info" />
                <em>
                  New joiners do not receive any leave during the first 6 months (Probation Period).
                  They must apply for LOP during this period.
                </em>
              </div>

              <div className="leave-note-item">
                <FiCheckCircle size={18} className="leave-note-icon text-info" />
                <em>
                  Every permanent employee earns one leave per month.
                </em>
              </div>

              <div className="leave-note-item">
                <FiCheckCircle size={18} className="leave-note-icon text-info" />
                <em>
                  If an employee does not have sufficient leave balance, they must apply for LOP.
                </em>
              </div>

              <div className="leave-note-item">
                <FiCheckCircle size={18} className="leave-note-icon text-info" />
                <em>
                  If an employee leaves the organization before the year ends, any advanced leave
                  availed will be adjusted during the final settlement.
                </em>
              </div>

              <div className="leave-note-item">
                <FiCheckCircle size={18} className="leave-note-icon text-info" />
                <em>Holidays are not counted as leave days.</em>
              </div>

              <div className="leave-note-item">
                <FiCheckCircle size={18} className="leave-note-icon text-info" />
                <em>
                  If both Friday and Monday are applied as leave, the total leave count will be
                  4 days, as Saturday and Sunday are included.
                </em>
              </div>
            </div>
          </div>



          <div
            className={`modal leave-modal ${show ? "d-block" : "d-none"}`}
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">LEAVE APPLICATION</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleClose}
                  ></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleSubmit}>
                    {/* Row 1: Leave Type, Start Date, End Date */}
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label htmlFor="leaveCode" className="form-label">
                          Leave Type <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          id="leaveCode"
                          value={leaveData.leaveCode || ""}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select..</option>
                          {leavetypelist && (
                            <>
                              {(clList?.leaveDays > 0) &&
                                leavetypelist
                                  .filter((leave) => leave.leaveCode === "CL")
                                  .map((leave, index) => (
                                    <option key={index} value={leave.leaveCode}>
                                      {`${leave.leaveDesc} (${leave.leaveCode})`}
                                    </option>
                                  ))}

                              {((clList?.leaveDays ?? 0) === 0) &&
                                leavetypelist
                                  .filter((leave) => leave.leaveCode !== "CL" && leave.leaveCode !== "COM")
                                  .map((leave, index) => (
                                    <option key={index} value={leave.leaveCode}>
                                      {`${leave.leaveDesc} (${leave.leaveCode})`}
                                    </option>
                                  ))}
                            </>
                          )}
                        </select>
                      </div>
                      {/* {clList?.leaveDays > 0 && ( */}
                      <div className="col-md-6">
                        <label htmlFor="leaveCode" className="form-label">
                          Day Type <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          id="dayType"
                          value={leaveData.dayType || ""}
                          onChange={handleChange}
                          required
                        >
                          <option value="F" >Full Day</option>
                          <option value="H">Half Day</option>
                        </select>
                      </div>
                      {/* )} */}

                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label htmlFor="startDate" className="form-label">
                          Start Date <span className="text-danger">*</span>
                        </label>
                        <DatePicker
                          selected={leaveData.startDate ? new Date(leaveData.startDate) : null}
                          onChange={(date) => handleDateChange(date, "startDate")}
                          className="form-control"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="Start Date"
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 1))}
                          maxDate={new Date(new Date().getFullYear(), 11, 31)}
                          onKeyDown={(event) => event.preventDefault()}
                        />
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="endDate" className="form-label">
                          End Date <span className="text-danger">*</span>
                        </label>
                        <DatePicker
                          selected={leaveData.endDate ? new Date(leaveData.endDate) : null}
                          onChange={(date) => handleDateChange(date, "endDate")}
                          className="form-control"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="End Date"
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          minDate={leaveData.startDate ? new Date(leaveData.startDate) : new Date()}
                          maxDate={new Date(new Date().getFullYear(), 11, 31)}
                          onKeyDown={(event) => event.preventDefault()}
                          disabled={leaveData.dayType === "H"}
                        />
                      </div>
                    </div>


                    {/* Row 2: Description */}
                    <div className="mb-3">
                      <label htmlFor="remark" className="form-label">
                        Description <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        id="remark"
                        rows="3"
                        placeholder="Enter a description"
                        value={leaveData.remark || ""}
                        onChange={handleChange}
                        required
                      ></textarea>
                    </div>
                    <hr />
                    <div className="text-center">
                      <button type="submit" className={`btn ${leaveData.actionType === "INSERT" ? "btn-success" : "btn-warning"}`} disabled={isSubmitting}>
                        {isSubmitting ? "Submitting..." :
                          (leaveData.actionType === "INSERT" ? "Submit" : "Update")}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          {showInfo && (
            <div
              className="modal fade leave-modal show"
              tabIndex="-1"
              style={{
                display: "block",
                backgroundColor: "rgba(0,0,0,0.5)",
              }}
            >
              <div className="modal-dialog modal-md modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">LEAVE DESCRIPTION</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={handleInfoClose}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <p>
                      <strong>Leave Period:</strong> {infoLeaveData.startDate} to {infoLeaveData.endDate}
                    </p>
                    <p>
                      <strong>Remark:</strong> {infoLeaveData.remark || "N/A"}
                    </p>
                  </div>

                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default LeaveApply;
